/**
 * ThemeToggle — Cycles light → dark → system → light.
 * Icons: Sun (light), Moon (dark), Laptop (system).
 * Small pill button sized for the Navbar (h-9, ~36px).
 */
import React from 'react';
import { Sun, Moon, Laptop } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle = ({ className = '' }) => {
  const { theme, resolved, toggle } = useTheme();

  const Icon = theme === 'dark' ? Moon : theme === 'system' ? Laptop : Sun;
  const label =
    theme === 'dark'   ? 'Thème sombre — clic pour thème système'
  : theme === 'system' ? `Thème système (${resolved}) — clic pour thème clair`
  :                      'Thème clair — clic pour thème sombre';

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      data-testid="theme-toggle"
      className={
        'inline-flex items-center justify-center h-9 w-9 rounded-full ' +
        'text-stone-600 hover:text-orange-600 hover:bg-orange-50 ' +
        'dark:text-stone-300 dark:hover:text-orange-400 dark:hover:bg-stone-800 ' +
        'transition-colors ' +
        className
      }
    >
      <Icon className="h-4 w-4" />
    </button>
  );
};

export default ThemeToggle;
